import React from "react"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import HotspotText from "./HotspotText";

const HotspotCarousel = ({images, title, text}) => {
    const settings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        speed: 1000,
        autoplay: true,
        pauseOnHover: false,
        // adaptiveHeight: true
      };
    return (
        <div className="carousel-container image">
            <Slider {...settings}>
                {images.map(i => {
                    const {image, imageAlt} = i
                    return (
                        <div className="img-container">
                            <img src={image} alt={imageAlt}></img>
                        </div>
                    )  
                })}
            </Slider>
            <HotspotText title={title} text={text} />      
        </div>
    )
}

export default HotspotCarousel;